import { render } from "./BlankPageSalesTen.vue?vue&type=template&id=3963c190&scoped=true"
import script from "./BlankPageSalesTen.vue?vue&type=script&lang=js"
export * from "./BlankPageSalesTen.vue?vue&type=script&lang=js"

import "./BlankPageSalesTen.vue?vue&type=style&index=0&id=3963c190&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3963c190"]])

export default __exports__